// ScheduleSuccess.jsx
// Confirmation popup shown after a meeting is scheduled. Auto-dismisses after a
// few seconds; also closes on click or Escape.

import React, { useEffect } from "react";

const MONTHS_FULL = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

// "2026-06-24" -> "24 June, 2026"
const fmtDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${parseInt(d, 10)} ${MONTHS_FULL[parseInt(m, 10) - 1]}, ${y}`;
};

// "11:00" -> "11:00 AM"
const fmt12 = (t) => {
  if (!t) return "";
  let [h, min] = t.split(":");
  h = parseInt(h, 10);
  const suffix = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${min} ${suffix}`;
};

const ScheduleSuccess = ({ meeting, onClose, autoCloseMs = 3500 }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    const t = autoCloseMs ? setTimeout(() => onClose?.(), autoCloseMs) : null;
    return () => {
      document.removeEventListener("keydown", onKey);
      if (t) clearTimeout(t);
    };
  }, [onClose, autoCloseMs]);

  const date = fmtDate(meeting?.selected_date || meeting?.date);
  const time = fmt12(meeting?.selected_time || meeting?.start_time || meeting?.time);
  
  const isTrial = meeting?.isTrial;

  return (
    <div className="bm-success-overlay" onMouseDown={onClose}>
      <div
        className="bm-success-modal"
        role="alertdialog"
        aria-label="Meeting scheduled"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <span className="bm-success-icon">
          <i className="fa-solid fa-check" />
        </span>
        <h3 className="bm-success-title">
          {isTrial ? "🎉 Free Trial Session Scheduled!" : "Meeting Scheduled Successfully!"}
        </h3>
        <p className="bm-success-text">
          {isTrial ? (
            <>
              Congratulations! Your 1st free trial session has been scheduled.
              <br />
              <strong>Make the most of it!</strong>
              <br />
              <br />
            </>
          ) : (
            <>
              Your meeting has been scheduled for
              <br />
            </>
          )}
          {date}
          {date && time ? " at " : ""}
          {time}
        </p>
      </div>
    </div>
  );
};

export default ScheduleSuccess;